import styled from 'styled-components';

import {
  KPI_COL_WIDTH,
  KPI_LEFT_COL_MAX_WIDTH,
  KPI_LEFT_COL_MIN_WIDTH,
} from './constants';

export const Col = styled.div<{
  alignRight?: boolean;
  minWidth?: boolean;
  maxWidth?: boolean;
}>`
  flex: 1;
  max-width: ${(props) =>
    props.maxWidth ? `${KPI_LEFT_COL_MAX_WIDTH}px` : undefined};
  min-width: ${(props) =>
    props.minWidth
      ? `${KPI_COL_WIDTH}px`
      : props.maxWidth
        ? `${KPI_LEFT_COL_MIN_WIDTH}px`
        : undefined};
  width: ${(props) =>
    props.minWidth || props.maxWidth ? undefined : `${KPI_COL_WIDTH}px`};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.alignRight ? 'flex-end' : 'flex-start')};
`;
